// Revolt Button Component
// Unified button component matching the upgrade button styling
// Used throughout the application for consistency

import './RevoltButton.css';

export function RevoltButton({
  children,
  variant = 'primary', // 'primary', 'outline', 'danger', 'ghost'
  size = 'default', // 'default' or 'sm'
  as: Component = 'button', // 'button', 'a', or React component
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  ...props
}) {
  const buttonClasses = [
    'revolt-btn',
    `revolt-btn-${variant}`,
    `revolt-btn-${size}`,
    className
  ].filter(Boolean).join(' ');

  const commonProps = {
    className: buttonClasses,
    onClick,
    ...props
  };

  // Handle different element types
  if (Component === 'button') {
    return (
      <button
        type={type}
        disabled={disabled}
        {...commonProps}
      >
        {children}
      </button>
    );
  }

  if (Component === 'a') {
    // Remove button-specific props for anchor tags
    const { type: _, disabled: __, ...anchorProps } = commonProps;
    return (
      <a {...anchorProps}>
        {children}
      </a>
    );
  }

  // Custom component
  return (
    <Component {...commonProps}>
      {children}
    </Component>
  );
}

// Higher-order component for links styled as buttons
export function RevoltButtonLink({
  children,
  variant = 'primary',
  size = 'default',
  className = '',
  ...props
}) {
  const linkClasses = [
    'revolt-btn',
    `revolt-btn-${variant}`,
    `revolt-btn-${size}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <a
      className={linkClasses}
      {...props}
    >
      {children}
    </a>
  );
}
